import { render } from "./LongTermPlanView.vue?vue&type=template&id=6bd377e2&scoped=true"
import script from "./LongTermPlanView.vue?vue&type=script&lang=js"
export * from "./LongTermPlanView.vue?vue&type=script&lang=js"

import "./LongTermPlanView.vue?vue&type=style&index=0&id=6bd377e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd377e2"]])

export default __exports__